module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_6000.73bb46d9.png";